export default function buildPipelineOutputGate({
  hasValidInput,
  clusterId,
  pipelineSelected,
  pipelineDataLoading,
  canTransformEvent,
}) {
  const disabled = !hasValidInput || !clusterId || !pipelineSelected || pipelineDataLoading || !canTransformEvent;

  let tooltip;
  if (!clusterId) {
    tooltip = 'Select a cluster to run the end-to-end test';
  } else if (!pipelineSelected) {
    tooltip = 'Select a pipeline to run the end-to-end test';
  } else if (!hasValidInput) {
    tooltip = 'A valid input event is required';
  } else if (pipelineDataLoading) {
    tooltip = 'Loading pipeline configuration...';
  } else if (!canTransformEvent) {
    tooltip = 'You do not have permission to transform events';
  }

  return { disabled, tooltip };
}
